import React, { useState, useEffect } from "react";
import image from "../../../Resources/images/images.jpg";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import Table from "../../UI/Table/Table";
import axios from "../../../HOC/CreateAxios/CreateAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MasterDeleteModal from "../../UI/Model/MasterDeleteModel/MasterDeleteModel";
function ViewProduct({ showProduct, searchText }) {
  const [Tbody, setTbody] = useState([]);
  const [idStore, setIdStore] = useState(false);
  const [message, setMessage] = useState(false);
  const [storeImage, setStoreImage] = useState("");
  const [ID, setID] = useState("");
  const [storeID, setStoreID] = useState(false);
  const [Description, setDescription] = useState("");

  const [showModel, setShowModel] = useState(false);
  const formats = [
    "header",
    "fonts",
    "size",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
    "image",
    "video",
  ];
  const modules = {
    toolbar: [
      [
        { header: "1" },
        { header: "2" },
        { header: [3, 4, 5] },
        {
          font: [],
        },
      ],
      [{ size: [] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image", "video"],
      ["clear"],
    ],
  };
  const Schema = yup.object().shape({
    product_name: yup.string().required("Product name name is required"),
    product_quantity: yup
      .string()
      .required("Product quantity name is required"),
    // product_quantity: yup.string().required("Category name is required"),
    // image: yup.string().required("Image is required"),
    // allData: yup.string().required("Email is required"),
  });
  const FormInitial = [
    {
      label: "Product Name",
      apiKey: "product_name",
      placeholder: "Enter product name  ",
      type: "text",
    },
    // {
    //   label: "Brand",
    //   apiKey: "product_brand",
    //   type: "select",
    //   // options: [{ value: "Select brand", id: "0" }, ...BrandOptions],
    // },
    // {
    //   label: "Category",
    //   apiKey: "product_category",
    //   type: "select",
    //   // options: [{ value: "Select category", id: "0" }, ...CategoryOptions],
    // },

    {
      label: "Quantity",
      apiKey: "product_quantity",
      placeholder: "Enter product quantity ",
      type: "number",
    },
    {
      type: "quill",
      label: "description",
      apikey: "desc",
      placeholder: "enter description here!!",
    },
  ];
  const getProduct = () => {
    axios
      .get("/product")
      .then((res) => {
        // console.log(res);
        setTbody(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getProduct();
  }, []);
  const DeleteItems = () => {
    // console.log(idStore);
    axios
      .delete(`/product/${idStore}`)
      .then((res) => {
        if (res.status === 200) {
          setMessage(false);
          getProduct(idStore);
          toast.error("Data has been deleted sucessfully");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
    // console.log(id);
  };
  useEffect(() => {
    getProduct();
  }, []);
  // let ConformationMessage;
  // if (message) {
  //   ConformationMessage = (
  //     <MasterDeleteModal
  //       id={idStore}
  //       Delete={DeleteItems}
  //       setMessage={setMessage}
  //     />
  //   );
  // }
  const Edit = (values) => {
    setID(values);
    // setStoreImage(values?.image);
    // setStoreImage([...values.image]);

    setShowModel(true);
    // console.log(values);
    // setStoreImage([...values.image]);
  };
  console.log(ID);
  useEffect(() => {
    setStoreID(ID);
  }, [ID, storeID]);
  const Submits = (value) => {
    // value.details = storeDescription;
    // value.image = storeImage;
    // console.log(value);
    // let formData = new FormData();
    // formData.append("Brand_name", value.Brand_name);
    // formData.append("image", value.image);
    // storeImage.map((val, i) => {
    //   return formData.append("image", val);
    // });
    // value.name = ID.name;
    // value.tId = ID.tId;
    // value.createdAt = ID.createdAt;
    // console.log(value);
    // alert(9);
    value.desc = Description;
    setShowModel(false);
    axios
      .patch(`/product/${ID.id}`, value)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setShowModel(false);
          setDescription("");
          toast.info("Brand has been updated sucessfuly");
          getProduct();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChange = (e) => {
    // alert("working");
    if (e.target.files.length !== 0) {
      setStoreImage(e.target.files[0]);
    }
  };
  let mod;
  mod = (
    <div
      className={`${
        showModel ? " absolute  z-50 top-0 bottom-0 right-0 left-0" : ""
      }`}
    >
      <div
        className={` ${
          showModel ? "translate-y-0 " : "-translate-y-full "
        }  duration-700 delay-300 ease-in-out fixed top-0 bottom-0 right-0 left-0  z-40 `}
      >
        <div
          className=" relative z-50 bg-[white] rounded-md top-[2%]  flex 
         p-5 w-[70%] mx-auto  h-fit"
        >
          <div className="w-[95%] my-4">
            <Formik
              initialValues={{
                product_name: ID?.product_name ? ID?.product_name : "",
                product_quantity: ID?.product_quantity
                  ? ID?.product_quantity
                  : "",
                product_category: ID?.product_category
                  ? ID?.product_category
                  : "",
                product_brand: ID?.product_brand ? ID?.product_brand : "",
                // desc: ID?.desc ? ID?.desc : "",
                // image: ID?.image ? ID?.image : "",
              }}
              validationSchema={Schema}
              onSubmit={(values, { resetForm }) => {
                Submits(values);
                resetForm();
              }}
            >
              {({ values, errors, touched, handleSubmit, isSubmitting }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className={`   gap-6`}>
                      {FormInitial?.map((val, i) => {
                        if (val.type === "file") {
                          return (
                            <div key={i} className="full ">
                              <div className="capitalize  my-3">
                                <label
                                  className="cursor-pointer text-gray-600 font-semibold"
                                  htmlFor={val.apiKey}
                                >
                                  {val.label}
                                </label>
                              </div>

                              {/* <div className="grid grid-cols-12  space-x-1 gap-3 border p-1 h-64 "> */}
                              <label htmlFor="image">
                                <div className=" w-full">
                                  <div className="w-full h-full  relative  p-1.5 overflow-hidden">
                                    <img
                                      src={
                                        storeImage
                                          ? URL.createObjectURL(storeImage)
                                          : `${process.env.REACT_APP_API_URL}/public/${ID?.image}`
                                      }
                                      alt="Loading..."
                                      className="object-cover mx-5 w-full h-96 object-top"
                                    />
                                  </div>
                                </div>
                              </label>
                              {/* </div> */}
                              <input
                                id="image"
                                type={"file"}
                                accept={val.accept}
                                name={val.apiKey}
                                onChange={(e) => handleChange(e)}
                                className="bg-white hidden relative z-50  outline-none rounded-sm 
                                    border-none px-2 py-1"
                              />
                              <div
                                className={`${
                                  errors[val.apiKey] && touched[val.apiKey]
                                    ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                    : ""
                                }`}
                              >
                                {errors[val.apiKey] && touched[val.apiKey]
                                  ? errors[val.apiKey]
                                  : ""}
                              </div>
                            </div>
                          );
                        } else if (val.type === "quill") {
                          return (
                            <div key={i} className="mt-4 w-full flex flex-col">
                              <label
                                htmlFor="image"
                                className="poppins font-medium pb-2"
                              >
                                Product Desription
                              </label>
                              <ReactQuill
                                style={{
                                  height: "200px !important",
                                  border: `none !important`,
                                }}
                                className="fold:w-11/12 placeholder: capitalize h-[150px] quill-container  "
                                modules={modules}
                                formats={formats}
                                // value={Description}
                                defaultValue={ID?.desc}
                                placeholder={val.placeholder}
                                onChange={(val) => {
                                  setDescription(val);
                                }}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <div key={i} className="full my-8 ">
                              <div className="capitalize  my-3">
                                <label
                                  className="cursor-pointer text-gray-600 font-semibold"
                                  htmlFor={val.apiKey}
                                >
                                  {val.label}
                                </label>
                              </div>
                              <div className="relative">
                                <Field
                                  id={val.apiKey}
                                  placeholder={val.placeholder}
                                  name={val.apiKey}
                                  className="border border-gray-300 px-3 py-2.5  w-11/12 laptop:w-full rounded-md"
                                />
                              </div>

                              <div
                                className={`${
                                  errors[val.apiKey] && touched[val.apiKey]
                                    ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                    : ""
                                }`}
                              >
                                {errors[val.apiKey] && touched[val.apiKey]
                                  ? errors[val.apiKey]
                                  : ""}
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                    <div className="flex justify-start  mt-20 w-11/12">
                      <button
                        type="submit"
                        className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
                      >
                        submit
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div
            className="absolute top-5 border border-gray-600  text-gray-600 bg-white  
            hover:bg-opacity-60  text-3xl rounded-full p-1 cursor-pointer right-10"
            onClick={() => {
              setShowModel(false);
              setID(null);
              setStoreImage("");
            }}
          >
            <MdClose />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
  useEffect(() => {
    getProduct();
  }, []);
  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }

  const tHead = [
    { title: "S.NO", width: "10%" },
    { title: "name", width: "20%" },
    { title: "image", width: "10%" },
    { title: "quantity", width: "10%" },
    { title: "price(Rs)", width: "10%" },
    { title: "Description", width: "30%" },
    { title: "action", width: "20%" },
  ];
  const thead = [
    { title: "s.nO", width: "10%" },
    { title: "price", width: "10%" },
    { title: "unit", width: "10%" },
    ,
  ];
  const Filter = (array) => {
    // console.log(searchText);
    return array.filter(
      (option) =>
        option["product_name"].toLowerCase().indexOf(searchText.toLowerCase()) >
        -1
    );
  };

  return (
    <div className=" p-6">
      <div
        className={`${
          showModel
            ? "fixed bg-black bg-opacity-10   overflow-auto  z-50 top-0 bottom-0 right-0 left-0"
            : ""
        } `}
      >
        <div
          className={` ${
            showModel ? "translate-y-0  " : "-translate-y-full  "
          }  duration-700 delay-300 ease-in-out   absolute top-0 bottom-0 right-0 left-0  z-40 `}
        >
          {showModel ? mod : ""}
        </div>
      </div>
      <Table celspacing={0} cellPadding={0} Head={tHead}>
        {Tbody.map((val, i) => {
          let image = `${process.env.REACT_APP_API_URL}/public/${val.image}`;
          return (
            <tr key={i} className=" w-full">
              <td className="border-b p-2 text-center border-l"> {i + 1}</td>
              <td className="border-b p-2 text-center">{val.product_name}</td>
              <td className="border-b p-2 ">
                <div className="flex justify-center ">
                  <img
                    src={image}
                    alt="loading ..."
                    height="40px"
                    width="40px"
                    className="rounded-full w-16 h-16"
                  />
                </div>
              </td>
              <td className="border-b p-2 text-center">
                {val.product_quantity}
              </td>

              <td className="border-b p-2 text-center ">
                <div className="h-32 bg-gray-200 overflow-scroll">
                  <Table
                    key={i}
                    className="flex gap-5 "
                    Head={thead}
                    height="priceUnit"
                  >
                    {val?.priceandunit?.map((vals, i) => {
                      return (
                        <tr>
                          <td className="text-red-900 py-3">{i + 1}</td>
                          <td className="py-3">{vals.unit}</td>
                          <td className="py-3">{vals?.price}</td>
                        </tr>
                      );
                    })}{" "}
                  </Table>
                </div>
              </td>
              <td
                className="border-b p-2 text-center"
                dangerouslySetInnerHTML={{ __html: val.desc }}
              ></td>
              <td className="border-b p-2 text-center border-r">
                <div className="flex mx-3 gap-2 items-center justify-center">
                  {" "}
                  <div className="">
                    <button
                      className="border border-gray-600 rounded-md  hover:bg-blue-100 hover:text-blue-500 px-2 py-1"
                      onClick={() => Edit(val)}
                    >
                      <MdEdit className="text-2xl" />
                    </button>
                  </div>
                  <div className="">
                    <button
                      className=" capitalize border border-[#9a9a9a] px-2 py-1 rounded-md hover:bg-red-100  hover:text-red-500"
                      onClick={() => Conformation(val.id)}
                    >
                      <MdDelete className="text-2xl" />
                    </button>
                  </div>
                  {ConformationMessage}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>
      <ToastContainer />
    </div>
  );
}

export default ViewProduct;
